import {
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2,
  GUIDED_SELLING_QUESTION3,
  PAST_ED_DIAGNOSIS,
  PREGNANCY,
  START_CLINICAL_BRANCH
} from "config/tags";
import {
  CLINICAL_PROGRAM,
  CORE_PRODUCT,
  NOT_ELIGIBLE_BULEMIA,
  NOT_ELIGIBLE_PREGNANCY,
  PREMIUM_PRODUCT
} from "./constants";
import { isSuicidal, mainIsEligibleSequence } from "utils/eligibility";
import { findAnswerByQuestionTag } from "utils/questions";

export const getResultsPageUniV4 = (answers, questions, profile) => {
  const firstAnswer = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION1,
    answers,
    questions
  );
  const secondAnswer = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION2,
    answers,
    questions
  );
  const thirdAnswer =
    findAnswerByQuestionTag(GUIDED_SELLING_QUESTION3, answers, questions) ||
    "No";
  const startClinicalBranch = findAnswerByQuestionTag(
    START_CLINICAL_BRANCH,
    answers,
    questions
  );

  // If the user has started the clinical branch.
  const isEligible =
    startClinicalBranch &&
    mainIsEligibleSequence(answers, profile, questions) &&
    !isSuicidal(answers, questions);
  if (isEligible) {
    return CLINICAL_PROGRAM;
  } else if (startClinicalBranch && !isEligible) {
    const isPregnant =
      findAnswerByQuestionTag(PREGNANCY, answers, questions)?.toLowerCase() ===
      "yes";
    const hasEatingDisorder =
      findAnswerByQuestionTag(
        PAST_ED_DIAGNOSIS,
        answers,
        questions
      )?.toLowerCase() === "yes";

    if (isPregnant) {
      return NOT_ELIGIBLE_PREGNANCY;
    } else if (hasEatingDisorder) {
      return NOT_ELIGIBLE_BULEMIA;
    } else {
      const partialAnswers = `${firstAnswer},${secondAnswer}`;

      switch (partialAnswers) {
        case "D,W":
        case "V,W":
        case "W,V":
        case "W,W":
          return PREMIUM_PRODUCT;
        default:
          return CORE_PRODUCT;
      }
    }
  }

  // If the user has not started the clinical branch.
  const allAnswers = `${firstAnswer},${secondAnswer},${thirdAnswer}`;
  switch (allAnswers) {
    case "D,D,Yes":
    case "D,V,Yes":
    case "D,W,Yes":
    case "V,W,Yes":
    case "W,V,Yes":
    case "W,W,Yes":
      return CLINICAL_PROGRAM;
    case "D,W,No":
    case "D,W,Currently":
    case "V,W,No":
    case "V,W,Currently":
    case "W,V,No":
    case "W,V,Currently":
    case "W,W,No":
    case "W,W,Currently":
      return PREMIUM_PRODUCT;
    default:
      return CORE_PRODUCT;
  }
};

export const getIsClinicEligibleUni4 = (answers, questions, profile) => {
  if (getResultsPageUniV4(answers, questions, profile) === CLINICAL_PROGRAM) {
    return true;
  }

  return false;
};
